import { useBookerContext } from "widgets/booker/contexts";
import { isBookingRequestCheckout } from "widgets/booker/shared/utils";

export const useIsBookingRequest = () => {
  const { booker, product, paymentRequestId, invoiceAdminMode } =
    useBookerContext();
  return (
    !invoiceAdminMode &&
    isBookingRequestCheckout({
      approvalEnabled: booker?.approvalSettings?.enabled,
      paymentRequestId,
      productType: product?.type,
    })
  );
};
